import { type Variants } from "motion/react";

export const animationVariants: Variants = {
  buttons: {
    transition: { delay: 0.5, duration: 1 },
    opacity: [0, 0.75, 1],
  },
};
